export enum LazyLoadOptions {
  NO_LAZY_LOAD = 'noLazyLoad',
  LAZY_LOAD = 'lazyLoad',
  LAZY_PRE_LOAD = 'lazyPreLoad',
}
